import { Button, Drawer, Group, Stack } from '@mantine/core';
import type { AnySourceConfig, FilterValue, FilterValues } from '../types';
import { FilterField } from './FilterField';

interface Props {
  opened: boolean;
  source: AnySourceConfig;
  sourceKey: string;
  draft: FilterValues;
  /** key -> list of { value, label }, resolved by the orchestrator from the SDK. */
  runtimeOptions: Record<string, { value: string; label: string }[]>;
  onChange: (key: string, value: FilterValue) => void;
  onApply: () => void;
  onClear: () => void;
  onClose: () => void;
}

export function FilterDrawer({
  opened, source, sourceKey, draft, runtimeOptions, onChange, onApply, onClear, onClose,
}: Props) {
  return (
    <Drawer opened={opened} onClose={onClose} title={`Filter ${source.plural}`} position="right" size="md" padding="md">
      <Stack key={sourceKey}>
        {source.filters.map((def) => (
          <FilterField
            key={def.key}
            def={def}
            draft={draft}
            onChange={onChange}
            runtimeOptions={runtimeOptions[def.key]}
          />
        ))}
        <Group justify="flex-end" mt="sm">
          <Button variant="light" onClick={onClear}>Clear</Button>
          <Button onClick={onApply}>Apply</Button>
        </Group>
      </Stack>
    </Drawer>
  );
}